export default __webpack_public_path__ + "static/media/Flaticon.d6af1ffb.svg";